import React from "react";
import { Empty, Spin, Row, Col } from "antd";
import ScheduleTemplateCard from "./ScheduleTemplateCard";
import { ScheduleTemplate } from "../../../../../types/scheduleTemplate";

interface ScheduleTemplateGridProps {
  templates: ScheduleTemplate[];
  loading?: boolean;
  onEdit: (template: ScheduleTemplate) => void;
  onDelete: (id: string) => void;
  onSetDefault: (id: string) => void;
}

const ScheduleTemplateGrid: React.FC<ScheduleTemplateGridProps> = ({
  templates,
  loading,
  onEdit,
  onDelete,
  onSetDefault,
}) => {
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "48px 0" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (templates.length === 0) {
    return (
      <div style={{ padding: "48px 0" }}>
        <Empty
          description="No schedule templates found"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </div>
    );
  }

  return (
    <Row gutter={[24, 24]}>
      {templates.map((template) => (
        <Col key={template.id} xs={24} sm={12} lg={8} xl={6}>
          <ScheduleTemplateCard
            template={template}
            onEdit={onEdit}
            onDelete={onDelete}
            onSetDefault={onSetDefault}
          />
        </Col>
      ))}
    </Row>
  );
};

export default ScheduleTemplateGrid;
